<template>
  <div class="address-black-setting" v-loading="loading">
    <el-card class="box-card" shadow="hover">
      <template #header>
        <span class="card-header">获取CRM积分券</span>
      </template>

      <el-form :model="formData" :rules="rules" ref="formRef" label-width="0">
        <div class="setting-content">
          <el-switch class="li-switch" inactive-text="是否启用" v-model="formData.open_status_crm_get_point_coupon_list" active-color="#13ce66"
                     inactive-color="#ff4949" @change="handleSubmitPointCoupon" />
        </div>
      </el-form>
    </el-card>
    <el-card class="box-card" shadow="hover">
      <template #header>
        <span class="card-header">获取CRM优惠券</span>
      </template>

      <el-form :model="formData" :rules="rules" ref="formRef" label-width="0">
        <div class="setting-content">
          <el-switch class="li-switch" inactive-text="是否启用" v-model="formData.open_status_crm_get_all_coupon_list" active-color="#13ce66"
                     inactive-color="#ff4949" @change="handleSubmitAllCoupon" />
        </div>
      </el-form>
    </el-card>
    <el-card class="box-card" shadow="hover">
      <template #header>
        <span class="card-header">群黑名单开关</span>
      </template>

      <el-form :model="formData" :rules="rules" ref="formRef" label-width="0">
        <div class="setting-content">
          <el-switch class="li-switch" inactive-text="是否启用" v-model="formData.open_status_black_group" active-color="#13ce66"
                     inactive-color="#ff4949" @change="handleSubmitBlackGroup" />
        </div>
      </el-form>
    </el-card>
    <el-card class="box-card" shadow="hover">
      <template #header>
        <span class="card-header">地址黑名单开关</span>
      </template>

      <el-form :model="formData" :rules="rules" ref="formRef" label-width="0">
        <div class="setting-content">
          <el-switch class="li-switch" inactive-text="是否启用" v-model="formData.open_status_black_address" active-color="#13ce66"
                     inactive-color="#ff4949" @change="handleSubmitBlackAddress" />
        </div>
      </el-form>
    </el-card>
    <el-card class="box-card" shadow="hover">
      <template #header>
        <span class="card-header">阿里云风险识别开关</span>
      </template>

      <el-form :model="formData" :rules="rules" ref="formRef" label-width="0">
        <div class="setting-content">
          <el-switch class="li-switch" inactive-text="是否启用" v-model="formData.open_status_ali_saf" active-color="#13ce66"
                     inactive-color="#ff4949" @change="handleSubmitAliSaf" />
        </div>
      </el-form>
    </el-card>
    <el-card class="box-card" shadow="hover">
      <template #header>
        <span class="card-header">开售前加购自动拉黑</span>
      </template>

      <el-form ref="formRef" :model="formData" :rules="rules" label-width="0">
        <div class="setting-content">
          <el-switch v-model="formData.open_status_presale_early_add_cart_black_user" inactive-text="是否启用" active-color="#13ce66"
                     inactive-color="#ff4949" @change="handleSubmitPresaleEarlyAddCartBlackUser" />
        </div>
      </el-form>
    </el-card>
    <el-card class="box-card" shadow="hover">
      <template #header>
        <span class="card-header">商品预警开关</span>
      </template>

      <el-form :model="formData" :rules="rules" ref="formRef" label-width="0">
        <div class="setting-content">
          <el-switch class="li-switch" inactive-text="是否启用" v-model="formData.open_status_spu_warning" active-color="#13ce66"
                     inactive-color="#ff4949" @change="handleSubmitSpuWarning" />
        </div>
      </el-form>
    </el-card>
    <el-card class="box-card" shadow="hover">
      <template #header>
        <span class="card-header">库存接口是否使用满减</span>
      </template>

      <el-form :model="formData" :rules="rules" ref="formRef" label-width="0">
        <div class="setting-content">
          <el-switch class="li-switch" inactive-text="是否启用" v-model="formData.open_status_stock_full_minus" active-color="#13ce66"
                     inactive-color="#ff4949" @change="handleSubmitStockFullMinus" />
        </div>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import { getInfo, update } from './api'
export default {
  name: 'NpiPublicSetting',
  data() {
    return {
      loading: false,
      formData: {
        open_status_crm_get_point_coupon_list: true,
        open_status_crm_get_all_coupon_list: true,
        open_status_black_group: true,
        open_status_black_address: true,
        open_status_ali_saf: true,
        open_status_presale_early_add_cart_black_user: true,
        open_status_spu_warning: true,
        open_status_stock_full_minus: true
      },
      rules: {
      }
    }
  },
  mounted() {
    this.getInfo()
  },
  methods: {
    async withLoading(fn) {
      try {
        this.loading = true
        return await fn()
      } finally {
        this.loading = false
      }
    },
    async getInfo() {
      await this.withLoading(async () => {
        const res = await getInfo()
        const { data } = res.data
        this.formData = data
      })
    },
    async handleSubmit() {
      await this.$refs.formRef.validate()
      await this.withLoading(async () => {
        await update(this.formData)
        this.$message.success('设置成功')
      })
    },
    async handleSubmitPointCoupon() {
      await this.$refs.formRef.validate()
      await this.withLoading(async () => {
        await update({
          open_status_crm_get_point_coupon_list: this.formData.open_status_crm_get_point_coupon_list
        })
        this.$message.success('设置成功')
      })
    },
    async handleSubmitAllCoupon() {
      await this.$refs.formRef.validate()
      await this.withLoading(async () => {
        await update({
          open_status_crm_get_all_coupon_list: this.formData.open_status_crm_get_all_coupon_list
        })
        this.$message.success('设置成功')
      })
    },
    async handleSubmitBlackGroup() {
      await this.$refs.formRef.validate()
      await this.withLoading(async () => {
        await update({
          open_status_black_group: this.formData.open_status_black_group
        })
        this.$message.success('设置成功')
      })
    },
    async handleSubmitBlackAddress() {
      await this.$refs.formRef.validate()
      await this.withLoading(async () => {
        await update({
          open_status_black_address: this.formData.open_status_black_address
        })
        this.$message.success('设置成功')
      })
    },
    async handleSubmitAliSaf() {
      await this.$refs.formRef.validate()
      await this.withLoading(async () => {
        await update({
          open_status_ali_saf: this.formData.open_status_ali_saf
        })
        this.$message.success('设置成功')
      })
    },
    async handleSubmitPresaleEarlyAddCartBlackUser() {
      await this.$refs.formRef.validate()
      await this.withLoading(async () => {
        await update({
          open_status_presale_early_add_cart_black_user: this.formData.open_status_presale_early_add_cart_black_user
        })
        this.$message.success('设置成功')
      })
    },
    async handleSubmitSpuWarning() {
      await this.$refs.formRef.validate()
      await this.withLoading(async () => {
        await update({
          open_status_spu_warning: this.formData.open_status_spu_warning
        })
        this.$message.success('设置成功')
      })
    },
    async handleSubmitStockFullMinus() {
      await this.$refs.formRef.validate()
      await this.withLoading(async () => {
        await update({
          open_status_stock_full_minus: this.formData.open_status_stock_full_minus
        })
        this.$message.success('设置成功')
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.address-black-setting {
  .box-card {
    margin: 20px;

    .card-header {
      font-weight: bold;
    }

    .setting-content {
      display: flex;
      align-items: center;

      .el-form-item {
        margin: 0 10px;
        display: inline-block;
      }
    }
  }
}
</style>
